import styled from 'styled-components';

export const containerAccordionInside = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-direction: column;
`;
